export const FEATURE_NAME = '@zerops/zerops/feature/project-cost-limit-dialog';
